<template>
    <div class="warmSet interactionSet theftSet">
        <el-form ref="form" :model="form" label-width="150px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="防录屏跑马灯设置">
                <el-switch v-model="form.isopensteal" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                <span class="tips magin20">开启后，用户观看直播会出现个人ID信息，可有效防止录屏</span>
            </el-form-item>
            <!--防录屏设置-->
            <div class="theft_wrap" v-show="form.isopensteal">
                <div class="left_box">
                    <div class="box" v-if="form.iscopyright"><txtScroll :sendVal='itemTxt1'></txtScroll></div>
                    <txtScroll :sendVal='itemTxt' v-if="itemTxt.show"></txtScroll>
                    <!--<p class="crBox" v-show="form.copyright"><span v-html="copyrightText"></span></p>-->
                    <!--<p class="userName" :style="{fontSize: fontValue + 'px',opacity: opaValue,color:form.crfontcolor}">用户名称</p>-->
                </div>
                <div class="right_box">
                    <el-form-item label="版权声明" label-width="90px">
                        <el-switch v-model="form.iscopyright" :active-value=1 :inactive-value=0 :disabled="isEnd" @change="changeCopy"></el-switch>
                        <span class="tips magin20">开启后，在直播的顶部会出现版权提示。在横屏直播时，全屏观看状态下，会导致跑马灯失效。</span>
                        <div class="copyrightText" v-show="form.iscopyright">
                            <el-input :disabled="isEnd" type="textarea" v-model="form.copyrightmemo" maxlength="100" @change="changeText" placeholder="请输入版权声明。默认：【版权声明】本直播版权归提供者所有，仅限个人学习，严禁任何形式的录制、传播和账号分享。一经发现，平台将依法保留追究权，情节严重者将承担法律责任。"></el-input>
                        </div>
                        <!--<div class="copyrightText" v-show="form.iscopyright">{{copyrightText}}</div>-->
                    </el-form-item>
                    <el-form-item label="跑马灯样式" label-width="90px">
                        <div class="lamp_box">
                            <p>字体颜色</p>
                            <div class="fontColor">
                                <span v-for="(item,index) in colorList" :key="index" :style="{background: item.color}" @click="colorEvent(item.color)">
                                    <i class="el-icon-success" v-if="form.crfontcolor==item.color"></i>
                                </span>
                            </div>
                            <!--字体大小-->
                            <div class="flex_style">
                                <span class="label">字体大小</span>
                                <el-slider v-model="form.crfontsize" :format-tooltip="formatFont" :disabled="isEnd"></el-slider>
                                <span>100%</span>
                            </div>
                            <!--透明度-->
                            <div class="flex_style">
                                <span class="label">透明度</span>
                                <el-slider v-model="form.crtransparency" :format-tooltip="formatTooltip" :disabled="isEnd"></el-slider>
                                <span>100%</span>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="" label-width="150px">
                <el-button type="primary" class="saveBtn"  @click="saveEvent" v-if="!isEnd">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {uploadLiveSecuritySettings} from 'api/vliveV2Api'
    import txtScroll from './txtScroll'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "theftSet",
        data(){
            return{
                itemTxt: {txt:'用户名称',fontSize:'12px',color:'#000',top:'12px',show:true},
                itemTxt1: {txt:'【版权声明】本直播版权归提供者所有，仅限个人学习，严禁任何形式的录制、传播和账号分享。一经发现，平台将依法保留追究权，情节严重者将承担法律责任。',
                    fontSize:'12px',color:'#fff',top:'12px',copyright:true},
                opaValue:1,
                fontValue:12,
                form:{
                    liveid:'', //直播id
                    isopensteal:0, //是否打开跑马灯
                    iscopyright:0, //是否打开版权声明
                    crfontsize:0, //字体大小
                    crtransparency:0, //透明度
                    crfontcolor:'#000000', //字体颜色
                    copyrightmemo:'', //版权说明
                },
                colorList:[{
                    color:'#000000'
                },{
                    color:'#D50000'
                },{
                    color:'#0091EA'
                },{
                    color:'#6200EA'
                },{
                    color:'#00C853'
                },{
                    color:'#FFD600'
                },{
                    color:'#A1887F'
                },{
                    color:'#FF6D00'
                },{
                    color:'#FF4081'
                },{
                    color:'#FFFFFF'
                }],
                isEnd:false,
                selectColor:'#000000', //用户当前选择颜色
                copyrightText:'【版权声明】本直播版权归提供者所有，仅限个人学习，严禁任何形式的录制、传播和账号分享。一经发现，平台将依法保留追究权，情节严重者将承担法律责任。'
            }
        },
        mounted(){
            this.opaValue=this.form.crtransparency===0?1:this.form.crtransparency/100;
            this.form=JSON.parse(JSON.stringify(this.playInfo.antitheftinfo));
            this.itemTxt.color=this.playInfo.antitheftinfo.crfontcolor;
            this.itemTxt1.copyright=this.playInfo.antitheftinfo.iscopyright==1;
            this.itemTxt1.txt=this.playInfo.antitheftinfo.copyrightmemo?this.playInfo.antitheftinfo.copyrightmemo:this.itemTxt1.txt;
            this.isEnd=[10,100].indexOf(this.liveInfo.status)>=0
        },
        methods:{
            //switch版权说明开关
            changeCopy(val){
                if(val===1&&!this.playInfo.antitheftinfo.copyrightmemo){ //开启了
                    this.form.copyrightmemo=this.copyrightText
                }
            },
            //选择颜色
            colorEvent(val){
                if(!this.isEnd){
                    this.form.crfontcolor=val;
                    this.itemTxt.color = val;
                    this.itemTxtShow()
                }
            },
            formatFont(val){
                if(val===0){
                    this.fontValue=12
                    this.itemTxt.fontSize = '12px';
                    this.itemTxtShow()
                }else{
                    this.fontValue=12+(30-12)*val/100.0;
                    this.itemTxt.fontSize = this.fontValue+'px';
                    this.itemTxtShow()
                }
            },
            itemTxtShow(){ //显示隐藏
                this.itemTxt.show = false;
                this.itemTxt1.show = false;
                this.$nextTick(()=>{
                    this.itemTxt.show = true;
                    this.itemTxt1.show = true;
                })
            },
            formatTooltip(val){
                this.opaValue=val/100.0;
                this.itemTxt.opacity= this.opaValue;
                this.itemTxtShow()
                // if(val/100.0===0){
                //     this.opaValue=1
                //     this.itemTxt.opacity = 1;
                //     this.itemTxtShow()
                // }else if(val/100===1){
                //     this.opaValue=0
                //     this.itemTxt.opacity = 1-this.opaValue;
                //     this.itemTxtShow()
                // }else{
                //     this.opaValue=val/100
                //     this.itemTxt.opacity = 1-this.opaValue;
                //     this.itemTxtShow()
                // }
            },
            //改变input版权说明值
            changeText(){
                console.log(this.form.copyrightmemo)
                this.itemTxt1.txt=this.form.copyrightmemo
            },
            //保存
            saveEvent(){
                if(this.form.iscopyright==1&&this.form.copyrightmemo==''){
                    this.$message({
                        message: '请输入版权说明',
                        type: 'warning'
                    });
                    return
                }else{
                    if(this.form.iscopyright==0){
                        this.form.copyrightmemo=''
                    }
                    this.setLoading(true);
                    uploadLiveSecuritySettings({
                        data: Object.assign({}, this.form),
                        success: data => {
                            this.setLoading(false);
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'liveInfo','playInfo'
            ])
        },
        components:{
            txtScroll
        }
    }
</script>

<style lang="scss">
    .theftSet{
        .theft_wrap{
            display: flex;
            margin-left: 150px;
            .left_box{
                min-width: 408px;
                width:408px;
                height:230px;
                background:rgba(220,223,230,1);
                position: relative;
                overflow: hidden;
                .crBox{
                    height:28px;
                    line-height: 28px;
                    background:rgba(48,49,51,1);
                    border-radius:1px;
                    opacity:0.6;
                    font-size: 12px;
                    color: #fff;
                    margin: 10px;
                    /*width: 200%;*/
                    /*margin-left: 100%;*/
                    animation: myMove 30s linear infinite; // 重点，定义动画
                    animation-fill-mode: forwards;
                    /*overflow: hidden;*/
                    span{

                    }
                }
                @keyframes myMove {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-2500px);
                    }
                }
                .userName{
                    font-size: 12px;
                    margin-top: 20px;
                }
                .box{
                    position: relative;
                    height: 30px;
                    line-height: 30px;
                    margin: 10px;
                    overflow: hidden;
                    background:rgba(48,49,51,1);
                    opacity:0.6;
                    border-radius:1px;
                }
            }
            .right_box{
                margin-left: 30px;
                .copyrightText{
                    width:440px;
                    height: auto;
                    border-radius:1px;
                    border:1px solid rgba(192,196,204,1);
                    font-size: 13px;
                    color: #C0C4CC;
                    line-height: 20px;
                    padding: 10px;
                    margin-top: 12px;
                    .el-textarea__inner{
                        border: none;
                        padding: 0 0;
                        height: 55px!important;
                    }
                }
                .lamp_box{
                    .fontColor{
                        display: flex;
                        flex-wrap: wrap;
                        width: 400px;
                        margin-top: 12px;
                        span{
                            width: 50px;
                            height: 50px;
                            border-radius: 4px;
                            margin-right: 30px;
                            margin-bottom: 20px;
                            position: relative;
                            cursor: pointer;
                            .el-icon-success{
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%,-50%);
                                font-size: 30px;
                                color: #fff;
                            }
                        }
                        span:last-child{
                            border:1px solid rgba(228,231,237,1);
                            margin-right: 0;
                            .el-icon-success{
                                color: #606266;
                            }
                        }
                    }
                    .flex_style{
                        display: flex;
                        align-items: center;
                        color: #606266;
                        margin-bottom: 20px;
                        .label{
                            width: 100px;
                        }
                        .el-slider{
                            width: 100%;
                            margin: 0 10px;
                        }
                        .el-slider__button{
                            width: 12px;
                            height: 12px;
                            background: #409EFF;
                        }
                    }
                }
            }
        }
    }
</style>
